package br.com.texeratx.boardgametimeapp.ui.screens.games.model

data class PlayerOwnerUI(
    val id: Long,
    val name: String,
    val selected: Boolean = false
)